import { defineMessages } from 'react-intl';

export default defineMessages({

    noBillingTermsDirective: {
        id: 'ri.gateway.directives.BillingDirective.billingterms.There are no billing terms associated with this policy',
        defaultMessage: 'There are no billing terms associated with this policy'
    },
    noBillingTermsDataLabel: {
        id: 'gateway.directives.BillingDirective.billingterms.No Billing terms data for this policy, check back again in the next',
        defaultMessage: 'No billing terms data for this policy, check back again in the next 24 hour'
    }, 
    policyNumber: {
        id: 'ri.gateway.billingterms.Policy Number',
        defaultMessage: 'Policy Number'
    },
    policyEffective: {
        id: 'ri.gateway.billingterms.Eff. Date',
        defaultMessage: 'Eff. Date'
    },
    status: {
        id: 'ri.gateway.billingterms.Billing Status',
        defaultMessage: 'Billing Status'
    },
    billingAccount: {
        id: 'ri.gateway.billingterms.Billing Account',
        defaultMessage: 'Billing Account'
    },
    minAmountDue: {
        id: 'ri.gateway.billingterms.Min Amount Due',
        defaultMessage: 'Min Amount Due'
    },
    minAmountDue: {
        id: 'ri.gateway.billingterms.Due Date',
        defaultMessage: 'Due Date'
    },
    policyTermsTitle: {
        id: 'ri.gateway.billingterms.Title.Policy Billing Terms',
        defaultMessage: 'Policy Billing Terms'
    },
});
